import React from "react";
import {
  Box,
  Typography,
  Paper,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Block as BlockIcon,
} from "@mui/icons-material";


export default function PermissionDeniedPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ py: { xs: 4, md: 8 } }}>
      <Container maxWidth="sm">
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4,
            mt: { xs: 4, md: 8 },
            borderRadius: 2,
            textAlign: 'center',
            border: `2px solid ${theme.palette.error.main}`,
            bgcolor: 'background.paper'
          }}
        >
          <BlockIcon 
            sx={{ 
              fontSize: { xs: '3rem', md: '4rem' },
              color: 'error.main',
              mb: 2
            }} 
          />
          
          <Typography 
            variant={isMobile ? "h4" : "h3"} 
            component="h1"
            gutterBottom
            sx={{ 
              color: 'error.main',
              fontWeight: 600,
              mb: 2
            }}
          >
            Permission Denied
          </Typography>
          
          <Typography 
            variant="h6" 
            color="text.secondary"
            sx={{ 
              lineHeight: 1.6
            }}
          >
            You do not have permission to view this page
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
